/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 *  
 *  Requires js-cookie
 */

function CookieBar(containerSelector, cookieId, expirationYears){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var ANIMATION_TIMEOUT_DELAY = 1000;

	
	/* PRIVATE VARIABLES */
	var button;
	var expirationDays = 365;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = $(containerSelector);
		
		// set default validity
		if(expirationYears && !isNaN(expirationYears)) {
			expirationDays = Math.round(expirationYears * 365);
		}
		
		_this.init();
	}	


	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			button = $('button', _this.container);
			
			// check cookie status and show bar if not accepted yet
			var status = parseInt(Cookies.get(cookieId));
			if(status !== 1) {
				setTimeout(function(){
					_this.container.addClass('enabled');
					setTimeout(function(){
						_this.container.addClass('visible');
					}, 100);
				}, ANIMATION_TIMEOUT_DELAY);
			} else {
				_this.container.remove();
			}

			// save cookie accept and hide bar
			button.click(function(e){
				e.preventDefault();
				Cookies.set(cookieId, 1, { expires: expirationDays });
				_this.container.removeClass('visible');
				setTimeout(function(){
					_this.container.remove();
				}, ANIMATION_TIMEOUT_DELAY);				
			});		
			
			_this.inited = true;
		}
	};


	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
